import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-349939fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card bg-light bg-hover-opacity-50 cursor-pointer my-4" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-1" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "col-10 fs-3 ps-10 ps-lg-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-1 text-end" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right fs-1" })
], -1))

interface Props {
    icon: string,
    title: string
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    icon: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
    icon: string,
    title: string
  }

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: props.icon,
            class: "icon"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(props.title), 1),
        _hoisted_7
      ])
    ])
  ]))
}
}

})